import { render, staticRenderFns } from "./order-pie-charts.vue?vue&type=template&id=30ce17a2"
import script from "./order-pie-charts.vue?vue&type=script&lang=js"
export * from "./order-pie-charts.vue?vue&type=script&lang=js"
import style0 from "./order-pie-charts.vue?vue&type=style&index=0&id=30ce17a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports